// src/components/AudioGenerator/MusicSelector.js
import React from 'react';
import { Music2, Play, Pause } from 'lucide-react';
import { useAudioPlayer } from '../../hooks/useAudioPlayer';
import { BACKGROUND_MUSIC } from '../../constants/audio';

export const MusicSelector = ({ selectedMusicId, onMusicSelect }) => {
  const { play, stop, isPlaying, currentId } = useAudioPlayer();

  const handlePreview = (musicId, previewUrl) => {
    if (currentId === musicId && isPlaying) {
      stop();
    } else {
      play(previewUrl, musicId, 0.5);
    }
  };

  return (
    <div className="w-full">
      <div className="flex items-center gap-3 mb-4 text-purple-400">
        <Music2 className="w-5 h-5" />
        <h2 className="font-semibold">Background Music</h2>
      </div>
      <div className="bg-gray-800/50 backdrop-blur-xl rounded-2xl p-6 border border-gray-700/50">
        <div className="grid grid-cols-3 gap-4">
          {BACKGROUND_MUSIC.map(music => (
            <div
              key={music.id}
              onClick={() => onMusicSelect(music.id)}
              className={`group relative p-4 rounded-xl cursor-pointer transition-all ${
                selectedMusicId === music.id
                  ? 'bg-gradient-to-r ' + music.theme
                  : 'bg-gray-900/50 hover:bg-gray-800/50'
              }`}
            >
              <div className="flex flex-col gap-3">
                {/* Title and Play Button Row */}
                <div className="flex items-center justify-between">
                  <h3 className="font-semibold text-white text-lg">{music.name}</h3>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handlePreview(music.id, music.previewUrl);
                    }}
                    className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
                  >
                    {currentId === music.id && isPlaying ? (
                      <Pause className="w-5 h-5" />
                    ) : (
                      <Play className="w-5 h-5" />
                    )}
                  </button>
                </div>
                
                {/* Description */}
                <p className="text-sm text-gray-100/80 font-light line-clamp-2">
                  {music.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};